module.exports = __webpack_public_path__ + "img/subscription.12b7bad7.svg";